// @ts-check
// Retomar uma campanha pausada (spec/email.md seção 10.2; errata 14.3, item 5): depois da proteção do envio (muitas
// devoluções ou reclamações) só quem tem a flag WORKSPACE retoma, e confirmando o risco; nas outras pausas a confirmação
// é simples. O motor confere tudo de novo (403 sem a flag, 409 ACKNOWLEDGEMENT_REQUIRED sem a confirmação).
import { html } from 'htm/preact';
import { useState } from 'preact/hooks';
import { resumeEmailCampaign } from '../../data/email.js';
import { hasCurrentPermissionFlag } from '../../data/metadata-store.js';
import { resumeNeedsAcknowledgement } from '../../lib/email-campaigns.js';
import { Checkbox } from '../../ui/feedback.js';
import { Modal } from '../../ui/modal.js';
import { showErrorSnackbar, showSuccessSnackbar } from '../../ui/snackbar.js';
import { t } from '../../i18n/index.js';

/**
 * @param {{ campaign: import('../../data/email.js').EmailCampaign, onClose: () => void,
 *   onResumed: (campaign: import('../../data/email.js').EmailCampaign) => void }} props
 */
export function ResumeEmailCampaignDialog({ campaign, onClose, onResumed }) {
  const needsAcknowledgement = resumeNeedsAcknowledgement(campaign);
  const canAcknowledge = hasCurrentPermissionFlag('WORKSPACE');
  const [acknowledged, setAcknowledged] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const resume = async () => {
    setIsBusy(true);
    try {
      const resumed = await resumeEmailCampaign(campaign.id, needsAcknowledgement ? { acknowledgeRisk: true } : {});
      showSuccessSnackbar(t('emailCampaigns.toasts.resumed'));
      onResumed(resumed);
    } catch (error) {
      showErrorSnackbar(error);
    } finally {
      setIsBusy(false);
    }
  };
  if (!needsAcknowledgement) {
    return html`<${Modal} title=${t('emailCampaigns.actions.resume')} subtitle=${campaign.name} confirmLabel=${t('emailCampaigns.actions.resume')}
      isLoading=${isBusy} onClose=${onClose} onConfirm=${resume} />`;
  }
  return html`<${Modal} title=${t('emailCampaigns.resume.protectionTitle')} subtitle=${t('emailCampaigns.resume.protectionDescription')}
    confirmLabel=${t('emailCampaigns.actions.resume')} confirmAccent="danger" isLoading=${isBusy} isConfirmDisabled=${!canAcknowledge || !acknowledged}
    onClose=${onClose} onConfirm=${resume}>
    ${canAcknowledge
      ? html`<div class="ec-acknowledge" data-testid="email-campaign-acknowledge">
          <${Checkbox} checked=${acknowledged} onChange=${(/** @type {boolean} */ value) => setAcknowledged(value)} ariaLabel=${t('emailCampaigns.resume.acknowledge')} />
          <span onClick=${() => setAcknowledged((value) => !value)}>${t('emailCampaigns.resume.acknowledge')}</span>
        </div>`
      : html`<p class="ec-muted" role="note">${t('emailCampaigns.resume.needsWorkspace')}</p>`}
  <//>`;
}
